import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHelper } from '@umss/shared/utils';
import {
  CreateInvoiceRequest,
  GeneratedInvoice
} from '@umss/shared/data-access';
import {
  GenerateTimesheetsParams,
  GenerateTimesheetsResponse,
  RunPayCycleParams,
  RunPayCycleResult,
  RunSubscriptionCycleParams,
  RunSubscriptionCycleResult
} from '../dtos/pay-cycle-tools';

/**
 * Client for the "Force Generation" job endpoints documented in
 * TESTING-PAGE-BUSINESS-APP.md (pay cycle / staffing invoices / subscription billing).
 */
@Injectable({ providedIn: 'root' })
export class PayCycleToolsService {
  private readonly http = inject(HttpClient);

  // POST /api/timesheets/generate
  generateTimesheets(
    params: GenerateTimesheetsParams
  ): Observable<GenerateTimesheetsResponse> {
    return this.http.post<GenerateTimesheetsResponse>(
      '/api/timesheets/generate',
      null,
      { params: HttpHelper.toHttpParams(params) }
    );
  }

  // POST /api/facilities/{facilityId}/invoices/generate
  generateFacilityInvoice(
    facilityId: string,
    body: CreateInvoiceRequest
  ): Observable<GeneratedInvoice> {
    return this.http.post<GeneratedInvoice>(
      `/api/facilities/${facilityId}/invoices/generate`,
      body
    );
  }

  // POST /api/jobs/pay-cycle/run
  runPayCycle(params: RunPayCycleParams): Observable<RunPayCycleResult> {
    return this.http.post<RunPayCycleResult>('/api/jobs/pay-cycle/run', null, {
      params: HttpHelper.toHttpParams(params)
    });
  }

  // POST /api/jobs/subscription-cycle/run
  runSubscriptionCycle(
    params: RunSubscriptionCycleParams
  ): Observable<RunSubscriptionCycleResult> {
    return this.http.post<RunSubscriptionCycleResult>(
      '/api/jobs/subscription-cycle/run',
      null,
      { params: HttpHelper.toHttpParams(params) }
    );
  }
}
